import React from 'react'
import { Tooltip, Typography } from 'antd'
import classNames from 'classnames'
import { IAiProductPhoto } from '../types'
import styles from '../AiEnhancementModal.module.scss'

interface IPhotoPickerProps {
  photos: IAiProductPhoto[]
  selectedPhoto: IAiProductPhoto | null
  onSelect: (photo: IAiProductPhoto) => void
}

export const PhotoPicker: React.FC<IPhotoPickerProps> = ({
  photos,
  selectedPhoto,
  onSelect
}) => {
  if (!photos.length) {
    return (
      <Typography.Text className={styles.emptyText}>
        У товара нет доступных фото для AI-улучшения
      </Typography.Text>
    )
  }

  return (
    <div className={styles.photoGrid}>
      {photos.map((photo, index) => {
        const isDisabled = Boolean(photo.originFileObj)
        const isSelected = selectedPhoto?.uid === photo.uid

        const button = (
          <button
            key={photo.uid}
            type='button'
            className={classNames(styles.photoItem, {
              [styles.photoItemSelected]: isSelected,
              [styles.photoItemDisabled]: isDisabled
            })}
            onClick={() => {
              if (!isDisabled) {
                onSelect(photo)
              }
            }}
          >
            {photo.thumbUrl ? (
              <img src={photo.thumbUrl} alt={`Фото товара ${index + 1}`} />
            ) : (
              <span>Фото {index + 1}</span>
            )}
          </button>
        )

        if (!isDisabled) {
          return button
        }

        return (
          <Tooltip
            key={photo.uid}
            title='Сначала сохраните товар, чтобы отправить это фото на AI-улучшение'
          >
            {button}
          </Tooltip>
        )
      })}
    </div>
  )
}
